import React, { useState } from 'react';
import axios from '../../axiosConfig';
import { useNavigate, Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faUser, 
  faLock, 
  faPhone, 
  faMapMarkerAlt, 
  faImage, 
  faVenusMars, 
  faIdCard,
  faExclamationCircle,
  faCheckCircle,
  faEye,
  faEyeSlash
} from '@fortawesome/free-solid-svg-icons';
import Header from '../../components/Header';
import '../../styles/AuthPages.css';
import { useTranslation } from 'react-i18next';

const UserRegister = () => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    zhanghao: '', // 账号
    mima: '', // 密码
    xingming: '', // 姓名
    xingbie: '男', // 性别
    shouji: '', // 手机
    dizhi: '', // 地址
    tupian: '', // 图片
  });
  const [confirmPassword, setConfirmPassword] = useState(''); // 确认密码
  const [error, setError] = useState(''); // 错误信息
  const [success, setSuccess] = useState(''); // 成功信息
  const [isSubmitting, setIsSubmitting] = useState(false); // 提交状态
  const [showPassword, setShowPassword] = useState(false); // 显示密码
  const [showConfirmPassword, setShowConfirmPassword] = useState(false); // 显示确认密码
  const navigate = useNavigate();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    // 清除错误信息
    if (error) setError('');
  };

  const validateForm = () => {
    if (!formData.zhanghao.trim()) {
      setError(t('register.validation.accountRequired'));
      return false;
    }
    if (formData.zhanghao.length < 3) {
      setError(t('register.validation.accountMinLength'));
      return false;
    }
    if (!formData.mima) {
      setError(t('register.validation.passwordRequired'));
      return false;
    }
    if (formData.mima.length < 6) {
      setError(t('register.validation.passwordMinLength'));
      return false;
    }
    if (formData.mima !== confirmPassword) {
      setError(t('register.validation.passwordMismatch'));
      return false;
    }
    if (!formData.xingming.trim()) {
      setError(t('register.validation.nameRequired'));
      return false;
    }
    if (formData.shouji && !/^1[3-9]\d{9}$/.test(formData.shouji)) {
      setError(t('register.validation.phoneFormat'));
      return false;
    }
    return true;
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }

    setIsSubmitting(true);
    setError('');
    setSuccess('');

    try {
      const response = await axios.post('/yonghu/register', {
        ...formData,
        id: '', // id 为空字符串
      });

      if (response.data.code === 0) {
        setSuccess(t('register.registerSuccess'));
        setTimeout(() => {
          navigate('/login');
        }, 2000);
      } else {
        setError(response.data.msg || t('register.registerFailed'));
      }
    } catch (err) {
      console.error('Error registering user:', err);
      if (err.response?.data?.msg) {
        setError(err.response.data.msg);
      } else {
        setError(t('register.networkError'));
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="home-page">
      <Header />
      <div className="auth-container">
        <div className="auth-header">
          <h1>{t('register.title')}</h1>
          <p>{t('register.subtitle')}</p>
        </div>
        
        {error && (
          <div className="auth-error">
            <FontAwesomeIcon icon={faExclamationCircle} /> {error}
          </div>
        )}

        {success && (
          <div className="auth-message">
            <FontAwesomeIcon icon={faCheckCircle} /> {success}
          </div>
        )}
        
        <form className="auth-form" onSubmit={handleRegister}>
          <div className="form-group">
            <label htmlFor="zhanghao">
              <FontAwesomeIcon icon={faUser} /> {t('register.account')} *
            </label>
            <input
              id="zhanghao"
              type="text"
              name="zhanghao"
              value={formData.zhanghao}
              onChange={handleInputChange}
              placeholder={t('register.accountPlaceholder')}
              required
              disabled={isSubmitting}
            />
          </div>

          <div className="form-group">
            <label htmlFor="mima">
              <FontAwesomeIcon icon={faLock} /> {t('register.password')} *
            </label>
            <div style={{ position: 'relative' }}>
              <input
                id="mima"
                type={showPassword ? "text" : "password"}
                name="mima"
                value={formData.mima}
                onChange={handleInputChange}
                placeholder={t('register.passwordPlaceholder')}
                required
                disabled={isSubmitting}
                style={{ paddingRight: '40px' }}
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                style={{
                  position: 'absolute',
                  right: '10px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  border: 'none',
                  background: 'transparent',
                  cursor: 'pointer',
                  color: '#666'
                }}
              >
                <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
              </button>
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="confirmPassword">
              <FontAwesomeIcon icon={faLock} /> {t('register.confirmPassword')} *
            </label>
            <div style={{ position: 'relative' }}>
              <input
                id="confirmPassword"
                type={showConfirmPassword ? "text" : "password"}
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                placeholder={t('register.confirmPasswordPlaceholder')}
                required
                disabled={isSubmitting}
                style={{ paddingRight: '40px' }}
              />
              <button
                type="button"
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                style={{
                  position: 'absolute',
                  right: '10px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  border: 'none',
                  background: 'transparent',
                  cursor: 'pointer',
                  color: '#666'
                }}
              >
                <FontAwesomeIcon icon={showConfirmPassword ? faEyeSlash : faEye} />
              </button>
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="xingming">
              <FontAwesomeIcon icon={faIdCard} /> {t('register.name')} *
            </label>
            <input
              id="xingming"
              type="text"
              name="xingming"
              value={formData.xingming}
              onChange={handleInputChange}
              placeholder={t('register.namePlaceholder')}
              required
              disabled={isSubmitting}
            />
          </div>

          <div className="form-group">
            <label htmlFor="xingbie">
              <FontAwesomeIcon icon={faVenusMars} /> {t('register.gender')}
            </label>
            <select
              id="xingbie"
              name="xingbie"
              value={formData.xingbie}
              onChange={handleInputChange}
              disabled={isSubmitting}
              style={{
                width: '100%',
                padding: '12px',
                border: '1px solid #ddd',
                borderRadius: '4px',
                fontSize: '16px',
                boxSizing: 'border-box',
                backgroundColor: 'white'
              }}
            >
              <option value="男">{t('register.male')}</option>
              <option value="女">{t('register.female')}</option>
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="shouji">
              <FontAwesomeIcon icon={faPhone} /> {t('register.phone')}
            </label>
            <input
              id="shouji"
              type="tel"
              name="shouji"
              value={formData.shouji}
              onChange={handleInputChange}
              placeholder={t('register.phonePlaceholder')}
              disabled={isSubmitting}
            />
          </div>

          <div className="form-group">
            <label htmlFor="dizhi">
              <FontAwesomeIcon icon={faMapMarkerAlt} /> {t('register.address')}
            </label>
            <input
              id="dizhi"
              type="text"
              name="dizhi"
              value={formData.dizhi}
              onChange={handleInputChange}
              placeholder={t('register.addressPlaceholder')}
              disabled={isSubmitting}
            />
          </div>

          <div className="form-group">
            <label htmlFor="tupian">
              <FontAwesomeIcon icon={faImage} /> {t('register.avatar')}
            </label>
            <input
              id="tupian"
              type="url"
              name="tupian"
              value={formData.tupian}
              onChange={handleInputChange}
              placeholder={t('register.avatarPlaceholder')}
              disabled={isSubmitting}
            />
          </div>

          <button 
            type="submit" 
            className="auth-btn" 
            disabled={isSubmitting}
          >
            {isSubmitting ? t('register.registering') : t('register.registerButton')}
          </button>
        </form>
        
        <div className="auth-links">
          <Link to="/uplogin">{t('register.loginLink')}</Link>
          <Link to="/login">{t('register.otherLoginLink')}</Link>
        </div>
      </div>
    </div>
  );
};

export default UserRegister;
